import Service from '../Service'

const preview = {

    getChartDataFromTopic(id) {
        return Service.get(`/api/preview/graph?topic_id=${id}`);
    }

}

export default preview;